import { generateQueryKey } from 'query';

export * from './mutations';
export * from './useConsentsQuery';

export const getConsentsKey = (params: { consentIds?: string[] }) => generateQueryKey(['consents', params]);
